// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerText {\n    font-family: 'Josefin Sans', sans-serif;\n    color: 'red';\n}\n", "",{"version":3,"sources":["webpack://src/views/home/components/header/header-style.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,YAAY;AAChB","sourcesContent":[".headerText {\n    font-family: 'Josefin Sans', sans-serif;\n    color: 'red';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
